import LowPoster from '@components/atoms/images/lowPoster';
import LowPosterDefault from '@shared/assets/images/png/lowPosterDefault.png';
import Poster from '@components/atoms/images/poster';
import PosterDefault from '@shared/assets/images/png/posterDefault.png';
import PosterPilotContainer from '@components/atoms/container/posterContainer';

interface Props {
  id?: string;
  lowPoster?: string;
  poster?: string;
}

export default function PilotPoster({ id, lowPoster, poster }: Props) {
  return (
    <PosterPilotContainer>
      <LowPoster key={'poster' + id} src={lowPoster || LowPosterDefault} />
      <Poster key={id} src={poster || PosterDefault} />
    </PosterPilotContainer>
  );
}
